module.exports = __webpack_public_path__ + "files/e28dcfd472459b4ab0da3b54b0c5c73f.png";